import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import useTroopScheduleStep from "./hooks/useTroopScheduleStep";

const TroopScheduleStep = ({
  onSelect,
  hideModal,
  params,
  selectMode,
  lookupType,
  selectModeParamData,
}) => {
  const troopScheduleStep = useTroopScheduleStep(
    onSelect,
    hideModal,
    params,
    selectMode,
    lookupType,
    selectModeParamData
  );
  console.log("param data", troopScheduleStep.paramsData);
  return (
    <div class="container container-fluid">
      <ButtonsSection ctaButtons={troopScheduleStep.leftButtons} align="left" />
      <div className="header-section">
        <h1>
          {troopScheduleStep.screen_title} -{" "}
          <span className="heading-cod">{troopScheduleStep.screenNumber}</span>
        </h1>
      </div>
      <SearchBox
        formFields={troopScheduleStep.formFields}
        dropdownValues={troopScheduleStep.dropdownValues}
        paramsData={troopScheduleStep.paramsData}
        updataParamData={troopScheduleStep.updateParamData}
      />
      <ButtonsSection ctaButtons={troopScheduleStep.ctaButtons} />
      <DisplayTable
        selectMode={selectMode}
        displayMode={selectMode}
        data={troopScheduleStep.data}
        parmKey={troopScheduleStep.parmKey}
        menuOptions={troopScheduleStep.menuOptions}
        tableHeaders={troopScheduleStep.columnDef}
        setRowData={troopScheduleStep.setRowData}
        selectedPriceSchedules={troopScheduleStep.selectedRows}
        setSelectedPriceSchedules={troopScheduleStep.setSelectedRows}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={troopScheduleStep.first}
          rows={troopScheduleStep.rows}
          totalRecords={troopScheduleStep.totalRecords}
          currentPage={troopScheduleStep.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={troopScheduleStep.onPageChange}
        />
      </div>
      {troopScheduleStep.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={troopScheduleStep.isConfirmationModalOpen}
          onRequestClose={troopScheduleStep.closeConfirmationModal}
          onBack={troopScheduleStep.closeConfirmationModal}
          onSave={troopScheduleStep.deleteTroopScheduleStep}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={troopScheduleStep.setSelectedOption}
        />
      )}
    </div>
  );
};

export default TroopScheduleStep;
